<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="enableDate" type="checkbox" value="{{fieldOptions.enableDate}}" 
      (ngModelChange)="dataChanged.emit($event)"
      [(ngModel)]="fieldOptions.enableDate">
    <span>
      <b>Enable date</b>
    </span>
  </label>
</div>